module.exports = __webpack_public_path__ + "static/media/special.5a06b3a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/special.mp3
// module id = Dh23
// module chunks = 1